import { upsertStyleTag, removeStyleTag } from "../../domStyles";

const ROOT = document.documentElement;

const CLASS = "incluway-invert-colors";
const STYLE_ID = "incluway-invert-colors-style";
const EXCLUDE = "#incluway-widget-root";

export function enableInvertColors() {
  ROOT.classList.add(CLASS);

  upsertStyleTag(
    STYLE_ID,
    `
html.${CLASS} body > *:not(${EXCLUDE}) {
  filter: invert(100%) !important;
  -webkit-filter: invert(100%) !important;
}
`.trim(),
  );
}

export function disableInvertColors() {
  ROOT.classList.remove(CLASS);
  removeStyleTag(STYLE_ID);
}
